// src/api/projects.ts

/**
 * Project API helpers for the Quantik Mind enterprise frontend.
 *
 * This module centralizes project-related API operations used by the frontend,
 * including project retrieval and project creation.
 */

import { api } from '../utils/apiClient';

/**
 * Project payload exposed by the backend API.
 */
export interface Project {
  /** Unique project identifier. */
  id: string;

  /** Human-readable project name. */
  name: string;

  /** Optional Prometheus endpoint associated with the project. */
  prometheus_url?: string;

  /** Project creation timestamp. */
  created_at: string;
}

/**
 * Retrieve all projects available to the authenticated user.
 *
 * @returns The list of accessible projects.
 */
export const fetchProjects = async (): Promise<Project[]> => {
  const data = await api.get<Project[]>('/projects/');
  return data;
};

/**
 * Create a new project.
 *
 * @param name - Human-readable project name.
 * @returns The created project returned by the backend.
 */
export const createProject = async (name: string): Promise<Project> => {
  const data = await api.post<Project>('/projects/', {
    name,
  });

  return data;
};
